import AccountBlock from './AccountBlock';
import BottomBlock from './BottomBlock';
import MainMenu from './MainMenu';
import classes from './Sidebar.module.scss';

export default function Sidebar() {
  return (
    <div className={classes.root}>
      <AccountBlock />
      <MainMenu />
      <BottomBlock />
    </div>
  );
}
